<template>
  <div class="tree-node horizontal">
    <div class="node-wrapper" :class="{ 'selected-node-wrapper': isSelected }">
      <div v-if="node.adjuntos_count > 0" class="adjuntos-indicator">
        {{ node.adjuntos_count }}
      </div>

      <v-card
        class="node-card pa-3 d-inline-flex align-center"
        outlined
        elevation="2"
        :class="{ selected: isSelected, 'con-categoria': categoria, 'nodo-marcado': marcado, 'nodo-marcable': seleccionMultiple }"
        :style="categoria ? { borderLeftColor: categoria.color } : null"
        :title="categoria ? `Categoría: ${categoria.nombre}` : null"
        :role="seleccionMultiple ? 'checkbox' : null"
        :aria-checked="seleccionMultiple ? String(marcado) : null"
        @click.stop="onSelect"
      >
        <v-icon v-if="seleccionMultiple" small class="mr-2" :color="marcado ? 'primary' : 'grey'">
          {{ marcado ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline" }}
        </v-icon>
        <img
          v-if="node.tipo && node.tipo[3]"
          :src="getImage(node.tipo)"
          class="node-banner mr-2"
          height="30"
        />

        <span class="node-text" v-html="highlightText(node.name)"></span>

        <!-- nota interna (solo llega a los usuarios de Ramos) -->
        <v-tooltip v-if="node.nota" bottom max-width="320" open-delay="200">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="amber darken-2" class="ml-2 icono-nota" aria-label="Tiene nota" v-bind="attrs" v-on="on">mdi-note-text</v-icon>
          </template>
          <span class="texto-nota-tooltip">{{ node.nota }}</span>
        </v-tooltip>

        <span
          v-if="categoria"
          class="categoria-chip ml-2"
          :style="{ backgroundColor: categoria.color }"
        >{{ categoria.nombre }}</span>

        <v-btn v-if="hasChildren" icon small @click.stop="toggle" class="toggle-btn ml-3">
          <v-icon :class="{ rotated: !node.expanded }" small>mdi-chevron-down</v-icon>
        </v-btn>
      </v-card>

      <div
        v-if="hasChildren && node.expanded"
        class="line-horizontal-right hidden-xs-only"
      ></div>

      <div v-if="isSelected && !seleccionMultiple" class="dialog-menu-container">
        <v-card class="action-toolbar pa-1 d-flex align-center elevation-4">
          <v-btn
            icon
            small
            color="primary"
            @click="$emit('view-files', node)"
            title="Ver documentación"
          >
            <v-icon small>mdi-file-document-multiple-outline</v-icon>
          </v-btn>

          <v-btn
            v-if="puedeEditar"
            icon
            small
            color="primary"
            @click="$emit('add-subnode', node)"
            title="Añadir subnodo"
          >
            <v-icon small>mdi-plus</v-icon>
          </v-btn>

          <v-divider vertical class="mx-1"></v-divider>

          <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-if="puedeAdjuntar" @click="$emit('attach-file', node)">
                <v-list-item-icon><v-icon small>mdi-paperclip</v-icon></v-list-item-icon>
                <v-list-item-title>Adjuntar archivo</v-list-item-title>
              </v-list-item>
              <v-list-item  v-if="verPlanos" @click="$emit('ver-plano', node)">
                <v-list-item-icon
                  ><v-icon small>mdi-file-eye-outline</v-icon></v-list-item-icon
                >
                <v-list-item-title>Ver en plano</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('ver-qr', node)">
                <v-list-item-icon><v-icon small>mdi-qrcode</v-icon></v-list-item-icon>
                <v-list-item-title>Ver QR</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="puedeOrdenar && node.children && node.children.length > 1" @click="$emit('ordenar-hijos', node)">
                <v-list-item-icon><v-icon small>mdi-sort</v-icon></v-list-item-icon>
                <v-list-item-title>Ordenar hijos</v-list-item-title>
              </v-list-item>
              <div v-if="puedeEditar">
                <v-divider></v-divider>
                <v-list-item @click="$emit('cambiar-padre', node)">
                  <v-list-item-icon><v-icon small>mdi-arrow-up</v-icon></v-list-item-icon>
                  <v-list-item-title>Cambiar padre</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('asignar-categoria', node)">
                  <v-list-item-icon><v-icon small>mdi-palette-outline</v-icon></v-list-item-icon>
                  <v-list-item-title>Categoría</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('editar-nota', node)">
                  <v-list-item-icon><v-icon small color="amber darken-2">mdi-note-text-outline</v-icon></v-list-item-icon>
                  <v-list-item-title>{{ node.nota ? "Editar nota" : "Añadir nota" }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('edit-title', node)">
                  <v-list-item-icon
                    ><v-icon small color="orange"
                      >mdi-pencil-outline</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title>Editar título</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('remove-node', node)">
                  <v-list-item-icon
                    ><v-icon small color="error"
                      >mdi-delete-outline</v-icon
                    ></v-list-item-icon
                  >
                  <v-list-item-title class="error--text">Eliminar</v-list-item-title>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </v-card>
      </div>
    </div>

    <transition name="fade-slide">
      <div v-if="hasChildren && node.expanded" class="children-wrapper horizontal">
        <div
          v-if="node.children.length > 1"
          class="line-vertical-children hidden-xs-only"
        ></div>
        <div class="children horizontal">
          <TreeNode
            v-for="child in node.children"
            :key="child.id"
            :node="child"
            :selectedNode="selectedNode"
            :searchQuery="searchQuery"
            :verPlanos="verPlanos"
            :puedeEditar="puedeEditar"
            :puedeAdjuntar="puedeAdjuntar"
            :puedeOrdenar="puedeOrdenar"
            :seleccionMultiple="seleccionMultiple"
            :marcados="marcados"
            @marcar="$emit('marcar', $event)"
            @cambiar-padre="$emit('cambiar-padre', $event)"
            @ordenar-hijos="$emit('ordenar-hijos', $event)"
            @select="$emit('select', $event)"
            @attach-file="$emit('attach-file', $event)"
            @view-files="$emit('view-files', $event)"
            @edit-title="$emit('edit-title', $event)"
            @remove-node="$emit('remove-node', $event)"
            @add-subnode="$emit('add-subnode', $event)"
            @ver-plano="$emit('ver-plano', $event)"
            @ver-qr="$emit('ver-qr', $event)"
            @asignar-categoria="$emit('asignar-categoria', $event)"
            @editar-nota="$emit('editar-nota', $event)"
            @toggle="$emit('toggle', $event)"
            horizontal
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* Mantenemos tu lógica de script intacta */
import { mapGetters } from "vuex";

export default {
  name: "TreeNode",
  props: {
    node: { type: Object, required: true },
    horizontal: { type: Boolean, default: true },
    selectedNode: Object,
    searchQuery: { type: String, default: "" }, // CAMBIO 3: Prop definida correctamente

    verPlanos: {type: Boolean, default: true},
    puedeEditar: {type: Boolean, default: true},
    puedeAdjuntar: {type: Boolean, default: true},
    puedeOrdenar: {type: Boolean, default: false},
    // selección múltiple: pulsar el nodo lo marca o desmarca en lugar de seleccionarlo
    seleccionMultiple: { type: Boolean, default: false },
    marcados: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters("armarios", ["categoriaDeArmario"]),
    categoria() {
      return this.categoriaDeArmario(this.node.id);
    },
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    marcado() {
      return this.seleccionMultiple && this.marcados.includes(this.node.id);
    },
    isSelected() {
      return this.selectedNode && this.selectedNode.id === this.node.id;
    },
  },
  methods: {
    // En methods de TreeNode.vue
    highlightText(text) {
      if (!this.$parent.searchQuery) return text;
      const query = this.$parent.searchQuery;
      const regExp = new RegExp(`(${query})`, "gi");
      return text.replace(regExp, '<mark class="yellow lighten-3">$1</mark>');
    },
    toggle() {
      this.$emit("toggle", this.node);
    },
    onSelect() {
      if (this.seleccionMultiple) this.$emit("marcar", this.node);
      else this.$emit("select", this.node);
    },
    getImage(tipo) {
      if (tipo) {
        const contenido = tipo.slice(0, -1).split(",")[3];
        return `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/banner/${contenido}`;
      }
      return "";
    },
  },
};
</script>

<style scoped>
/* ==========================================
   CONTENEDOR PRINCIPAL Y ESTRUCTURA
   ========================================== */
.tree-node {
  display: flex;
  flex-direction: row; /* Desktop: Horizontal */
  align-items: flex-start;
  position: relative;
  margin: 15px 0;
}

.node-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 30px;
  flex-shrink: 0; /* Evita que el nodo se comprima */
}

/* ==========================================
   TARJETA (CARD) - AJUSTADA PARA TEXTO LARGO
   ========================================== */
.node-card {
  border-radius: 10px;
  min-width: 160px; /* Ancho mínimo para que no se vea muy flaco */
  max-width: 350px; /* Ancho máximo razonable antes de saltar de línea */
  height: auto; /* IMPORTANTE: Permite que la tarjeta crezca verticalmente */
  background-color: #fafafa;
  border-color: #cfd8dc;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  cursor: pointer;
  z-index: 2;
  overflow: visible; /* Permite que indicadores sobresalgan */
}

.icono-nota {
  flex-shrink: 0;
}
.texto-nota-tooltip {
  white-space: pre-line;
}

.node-card.nodo-marcado {
  border-color: #117f9c !important;
  background-color: #e6f3f6;
  box-shadow: 0 0 0 2px rgba(17, 127, 156, 0.35);
}

.node-card.con-categoria {
  border-left-width: 6px;
  border-left-style: solid;
}

/* Etiqueta con el nombre de la categoría */
.categoria-chip {
  flex-shrink: 0;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1;
  padding: 3px 7px;
  border-radius: 10px;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.45);
}

.node-card.selected {
  border-color: #1976d2;
  background-color: #e3f2fd;
  box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3);
}

/* ==========================================
   TEXTO DEL NODO - CONFIGURACIÓN "NOMBRE COMPLETO"
   ========================================== */
.node-text {
  flex: 1; /* Toma todo el espacio entre la imagen y el botón */
  font-weight: 600;
  font-size: 0.95rem;
  color: #37474f;
  line-height: 1.3; /* Espaciado entre líneas para lectura fácil */

  /* REGLAS PARA VER TODO EL NOMBRE: */
  white-space: normal; /* Permite que el texto salte de línea */
  word-break: break-word; /* Rompe palabras muy largas si es necesario */
  overflow: visible; /* Asegura que no haya recortes */
  text-overflow: clip; /* Elimina los puntos suspensivos (...) */
  padding: 4px 0; /* Espacio interno para que el texto no toque bordes */
}

/* ==========================================
   LÍNEAS CONECTORAS (DESKTOP)
   ========================================== */
/* Línea que sale del padre hacia la derecha */
.line-horizontal-right {
  position: absolute;
  top: 25px; /* Alineado al centro de la primera línea de la tarjeta aprox. */
  right: -25px;
  width: 25px;
  height: 2px;
  background-color: #b9cbd4;
}

/* Contenedor de hijos */
.children-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}

/* Línea vertical que une a todos los hijos */
.line-vertical-children {
  position: absolute;
  left: -5px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #78909c;
}

.children.horizontal {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Línea horizontal que entra a cada hijo */
.children.horizontal > .tree-node::before {
  content: "";
  position: absolute;
  left: 0;
  top: 25px; /* Debe coincidir con el 'top' de line-horizontal-right */
  width: 28px;
  height: 2px;
  background-color: #78909c;
}

/* ==========================================
   BOTONES Y ELEMENTOS ADICIONALES
   ========================================== */
.dialog-buttons {
  margin-top: 10px;
  display: flex;
  gap: 6px;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 250px;
}

.adjuntos-indicator {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30%, -30%);
  background-color: #1976d2;
  color: white;
  font-weight: 700;
  font-size: 0.7rem;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3; /* justo por encima de la tarjeta del nodo (2): no debe tapar tooltips ni menús (8) */
}

.node-banner {
  border-radius: 4px;
  object-fit: contain;
  max-width: 40px;
  flex-shrink: 0;
}

.toggle-btn {
  flex-shrink: 0; /* Evita que el botón de flecha se aplaste */
}

.rotated {
  transform: rotate(-90deg);
  transition: transform 0.3s ease;
}

/* ==========================================
   RESPONSIVE (MÓVIL)
   ========================================== */
@media (max-width: 600px) {
  .tree-node {
    flex-direction: column;
    width: 100%;
  }

  .node-wrapper {
    margin-right: 0;
    margin-bottom: 5px;
    align-items: flex-start;
    width: 100%;
  }

  .node-card {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
  }

  .children-wrapper {
    margin-left: 15px; /* Indentación para móvil */
    padding-left: 10px;
    border-left: 1px dashed #b9cbd4;
    width: calc(100% - 15px);
  }

  .children.horizontal > .tree-node::before {
    width: 12px;
    left: -10px;
  }

  .dialog-buttons {
    justify-content: flex-start;
    max-width: 100%;
    padding: 5px;
  }

  .hidden-xs-only {
    display: none !important;
  }
}

/* Animaciones */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
